<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" offset="20">
                    <el-button type="success" size="mini" @click="getList()">查询</el-button>
                </el-col>
            </el-row>
        </div>
        <div>
            <el-tabs tab-position="left" @tab-click="handleClick" v-model="propertyName">
                <template v-for="item in picTabList">
                    <el-tab-pane :label="item.name" :name="item.type">
                        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
                            <el-table-column prop="propertyId" label="标识" v-show="">
                                <template slot-scope="scope">
                                    {{getShowStatus(scope.row.propertyId) ? '' : scope.row.propertyId}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="picName" label="图片名称"></el-table-column>
                            <el-table-column prop="picUrl" label="图片">
                                <template slot-scope="scope">
                                    <el-avatar :src="scope.row.picUrl"></el-avatar>
                                </template>
                            </el-table-column>
                            <el-table-column prop="linkUrl" label="连接地址"></el-table-column>
                            <el-table-column label="操作" fixed="right" width="230">
                                <template slot-scope="scope">
                                    <el-button-group>
                                        <el-button type="danger" size="mini" @click="edit(scope.row)">
                                            修改
                                        </el-button>
                                    </el-button-group>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </template>
            </el-tabs>
        </div>
        <el-dialog title="图片连接配置" :visible.sync="showDialog">
            <el-form :model="form" :rules="rules" ref="qrcode" label-width="100px" class="demo-ruleForm">
                <el-form-item label="自增主键" v-show="false">
                    <el-input v-model="form.propertyId" placeholder="自增主键"></el-input>
                </el-form-item>
                <el-form-item label="图片地址">
                    <img :src="form.propertyKey" disabled="true">
                </el-form-item>
                <el-form-item label="连接地址">
                    <el-input v-model="form.propertyValue" placeholder="图片连接 e.g http://www.baidu.com/a.jpg "></el-input>
                </el-form-item>
                <el-form-item label="图片类型" v-show="false">
                    <el-input v-model="form.propertyName" placeholder="图片类型"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="save()" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        saveActivePropertyApi,
        getActivePropertyList
    } from '../../api/api';
    export default {
        data() {
            var validateDate = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value <= this.active.beginTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                }else {
                    callback();
                }
            };
            var validateDate2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value >= this.active.endTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                }else {
                    callback();
                }
            };
            return {
                rules: {
                    activeName: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    beginTime: [
                        { type: 'string', required: true, message: '请选择日期', trigger: 'change' }
                    ],
                    endTime: [
                        { type: 'string', required: true, message: '请选择结束日期', trigger: 'change' },
                        { validator: validateDate, trigger: 'blur' }
                    ],
                    inviteNum:[
                        { type: 'number', message: '必须为数字'}
                    ],
                    joinNum: [
                        {required: true, message: '请输参团人数', trigger: 'blur'},
                        {min: 1, max: 10, message: '参团人数在1-10之间', trigger: 'blur'}
                    ],
                    grouponHour: [
                        {required: true, message: '拼团超时时间', trigger: 'blur'},
                        {min: 1, max: 48, message: '拼团超时时间在1-48小时之间', trigger: 'blur'}
                    ],
                    activeUrl: [
                        {required: true, message: '必须输入连接地址', trigger: 'blur'},
                        {min: 1, max: 256, message: '长度在 5 到 60 个字符', trigger: 'blur'}
                    ],
                    activeContent:[
                        {min: 1, max: 500, message: '长度在 5 到 60 个字符', trigger: 'blur'}
                    ]
                },
                formInline: {
                    activeNo: this.$route.query.activeNo,
                    bindCode: this.$route.query.bindCode,
                    propertyName: 'picActiveHead',
                    picType:'1',
                    currentPage: 1,
                    pageSize: 20,
                    recordsTotal: 0
                },
                propertyName:'picActiveHead',
                form: {
                    propertyId: '',
                    propertyKey: '',
                    bindCode: '',
                    propertyName: '',
                    propertyValue: '',
                    propertyRemark: '活动图片连接地址',
                    status: 1
                },
                picTabList:[{
                    name:'详情页大图',
                    type:'picActiveHead',
                    limitCount:999
                },{
                    name:'首页列表图',
                    type:'picActiveList',
                    limitCount:999
                },{
                    name:'营养图',
                    type:'picActiveYingyang',
                    limitCount:999
                },{
                    name:'长期订购图',
                    type:'picActiveLongPeriod',
                    limitCount:999
                },{
                    name:'小图',
                    type:'picActiveSmall',
                    limitCount:999
                },{
                    name:'详情页图',
                    type:'picActiveDetailBig',
                    limitCount:999
                },{
                    name:'推荐图',
                    type:'picActiveSuggest',
                    limitCount:999
                }],
                showDialog: false,
                loading: true
            }
        },
        //挂载时候执行
        mounted(){
            let _this = this;
            _this.$store.dispatch('initPropertyList',{activeNo:_this.$route.query.activeNo,bindCode:_this.$route.query.bindCode,propertyName:'picActiveHead'});
        },
        computed:{
            list:{
                get:function(){
                    return this.$store.getters.getList
                },
                set:function(val){
                    console.log(val)
                    this.$store.commit('INIT_PICTURE',val)
                }
            },
            picTabList:function () {
                return this.$store.getters.getPictureTabs
            }
        },
        methods: {
            getList(){
                this.$store.dispatch('initPropertyList',{activeNo:this.$route.query.activeNo,bindCode:this.$route.query.bindCode,propertyName:this.propertyName});
            },
            returnHistory(){
                window.history.back()
            },
            add(){
                this.form = {
                    propertyId: '',
                    propertyKey: '',
                    bindCode: '',
                    propertyName: '',
                    propertyValue: '',
                    propertyRemark: '活动图片连接地址',
                    status: 1
                }
                this.showDialog = true;
            },
            edit(row){
                this.showDialog = true;
                this.form = {
                    propertyId: row.propertyId,
                    propertyKey: row.picUrl,
                    bindCode: this.formInline.bindCode,
                    propertyName: row.propertyName||this.propertyName,
                    propertyValue: row.linkUrl,
                    propertyRemark: '活动图片连接地址',
                    status: 1
                }
            },
            handleClick(tab, event){
//                this.propertyName=tab.name;
//                this.form.propertyName=tab.name;
                this.getList();
            },
            getShowStatus(propertyId){
                return propertyId == null;
            },
            save(){
                if (this.form.propertyValue == "") {
                    this.$message({
                        message: "请输入连接地址",
                        type: 'error'
                    });
                    return;
                }
                if (this.form.propertyName == "") {
                    this.$message({
                        message: "请输选择类型",
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                let temp=this.form.propertyKey.replace('https://','').replace('http://','');
                this.form.propertyKey=temp.substring(temp.indexOf('/')+1);
                saveActivePropertyApi(this.form).then((res) => {
                    this.loading = false;
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.showDialog = false;
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            handlePic(row){
                let routerL = '/' + this.$route.path.split('/')[1];
                this.$router.push({
                    path: routerL + '/picture/' + row.bindCode,
                    query: {picType: '15', picName: row.proName, picState: 'product'}
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/active/activeProperty.vue